import React, { FC } from 'react'
import { theme, FontSizeProps } from '../../../../theme'

export const Aura: FC<{
  size?: FontSizeProps
}> = ({ size }) => {
  return (
    <svg
      width={theme.fontSizes[size!]}
      height={theme.fontSizes[size!]}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="5"
        width="20"
        height="14"
      >
        <rect x="2" y="5" width="20" height="14" rx="2" fill="#016FD0" />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 5H22.1786L22.2014 11.6001C19.6447 10.6277 11.51 8.30044 1 11.2005V5Z"
          fill="#2C328C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 19H22.1786V13.7198C18.359 12.4414 11.5694 10.5259 1 13.2397V19Z"
          fill="#FFF200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.1786 13.7198C18.359 12.4414 11.5694 10.5259 1 13.2397V11.2005C11.51 8.30042 19.6447 10.6309 22.2014 11.6L22.1786 13.7198Z"
          fill="#ED1C24"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.74652 9.95716C8.27055 8.50874 9.46997 7.25806 11.5539 7.27189C13.6378 7.28572 15.0277 8.47619 15.4028 10.0336C12.7175 9.75454 10.9273 9.70572 7.74652 9.95716Z"
          fill="#FFF200"
        />
        <path
          d="M5.73175 16.3253L7.15006 14.2097H7.67247L9.18354 16.3253H8.63021L8.19975 15.6849H6.65369L6.24683 16.3253H5.73175ZM6.79691 15.4571H8.04922L7.66351 14.872C7.56802 14.731 7.48081 14.5846 7.40231 14.4334C7.35224 14.5765 7.28532 14.7131 7.20295 14.8403L6.79609 15.4595L6.79691 15.4571ZM11.6678 16.3253V16.1007C11.459 16.2738 11.1758 16.3603 10.8183 16.3603C10.6695 16.3615 10.5211 16.3443 10.3764 16.309C10.2673 16.2866 10.1637 16.2424 10.0721 16.1789C10.0078 16.1297 9.95922 16.063 9.93216 15.9868C9.91022 15.9074 9.90089 15.825 9.90449 15.7427V14.7947H10.3577V15.6434C10.3527 15.7357 10.3621 15.8282 10.3854 15.9176C10.422 15.9938 10.4872 16.0523 10.5669 16.0804C10.6764 16.1221 10.7931 16.1417 10.9102 16.1382C11.0401 16.1392 11.1693 16.1191 11.2927 16.0788C11.3921 16.0525 11.4806 15.9956 11.5458 15.916C11.6013 15.8264 11.6275 15.7217 11.6206 15.6166V14.7947H12.0739V16.3253H11.6678ZM13.1732 16.3253V14.7947H13.58V15.0266C13.6601 14.9355 13.7586 14.8623 13.8689 14.8118C13.9616 14.7764 14.0602 14.7587 14.1594 14.7597C14.3183 14.7602 14.476 14.7877 14.6257 14.8411L14.4694 15.0852C14.3627 15.0478 14.2505 15.0286 14.1374 15.0283C14.0456 15.0268 13.9545 15.0443 13.8697 15.0795C13.7992 15.1067 13.7398 15.1569 13.7013 15.2219C13.6505 15.3146 13.6244 15.4189 13.6256 15.5246V16.3261L13.1732 16.3253ZM17.0359 16.1365C16.8806 16.2134 16.7167 16.2715 16.5477 16.3099C16.3831 16.3443 16.2154 16.3612 16.0472 16.3603C15.7535 16.3603 15.5281 16.3196 15.3694 16.2374C15.2107 16.1553 15.1326 16.0503 15.1326 15.9225C15.133 15.884 15.1411 15.8459 15.1565 15.8105C15.1719 15.7752 15.1942 15.7432 15.2221 15.7167C15.2881 15.6505 15.3678 15.5996 15.4557 15.5677C15.561 15.5293 15.6701 15.502 15.7812 15.4864C15.8698 15.4734 16.0041 15.4595 16.1831 15.4473C16.4543 15.4334 16.7244 15.4035 16.992 15.3578C16.992 15.322 16.992 15.3 16.992 15.2903C16.9954 15.2445 16.985 15.1988 16.962 15.159C16.9391 15.1192 16.9047 15.0873 16.8634 15.0673C16.7002 14.9996 16.5239 14.9695 16.3475 14.9794C16.1873 14.9716 16.027 14.9933 15.8747 15.0437C15.7728 15.087 15.6919 15.1685 15.6493 15.2707L15.2067 15.2358C15.2449 15.1301 15.3141 15.0385 15.4052 14.9729C15.5266 14.8943 15.6629 14.8416 15.8056 14.8183C16.0056 14.7801 16.209 14.7621 16.4126 14.7646C16.5992 14.7611 16.7857 14.7766 16.9692 14.811C17.0807 14.83 17.1877 14.8694 17.2849 14.9274C17.3488 14.9704 17.3979 15.0321 17.4257 15.1039C17.444 15.1823 17.4514 15.2628 17.4476 15.3432V15.689C17.4405 15.842 17.4503 15.9954 17.4769 16.1463C17.4997 16.216 17.5391 16.2791 17.5917 16.3302H17.1181C17.0713 16.2767 17.04 16.2114 17.0278 16.1414L17.0359 16.1365ZM16.9977 15.5572C16.7534 15.6069 16.506 15.6398 16.2572 15.6556C16.1243 15.6633 15.9921 15.6804 15.8617 15.7069C15.7963 15.7192 15.7349 15.7471 15.6827 15.7883C15.6637 15.8028 15.6482 15.8214 15.6373 15.8426C15.6263 15.8639 15.6201 15.8873 15.6192 15.9111C15.6192 15.9803 15.6656 16.0381 15.7567 16.0845C15.8836 16.1371 16.0207 16.1607 16.1579 16.1536C16.3158 16.1563 16.4731 16.1343 16.6242 16.0885C16.7391 16.0577 16.8431 15.9955 16.9244 15.9087C16.9785 15.8334 17.0044 15.7416 16.9977 15.6491V15.5572Z"
          fill="#2C328C"
          stroke="#2C328C"
          strokeWidth="0.22"
          strokeMiterlimit="22.93"
        />
      </g>
    </svg>
  )
}

Aura.defaultProps = {
  size: 'x3',
}
